module.exports = __webpack_public_path__ + "img/watertoken.585a16f8.png";